import { format, parse } from 'date-fns';

export function prettifyPhoneNumber(phoneNumber: string): string {
  const stripped = phoneNumber.trim();

  if (stripped && /^\+\d{11}$/.test(stripped)) {
    // +19174232712 -> (917) 423-2712
    return `(${stripped.slice(2, 5)}) ${stripped.slice(5, 8)}-${stripped.slice(8, 12)}`;
  }

  if (stripped && /^\d{10}$/.test(stripped)) {
    // 9174232712 -> (917) 423-2712
    return `(${stripped.slice(0, 3)}) ${stripped.slice(3, 6)}-${stripped.slice(6, 10)}`;
  }

  if (stripped && /^\d{11}$/.test(stripped) && stripped.startsWith('1')) {
    // 19174232712 -> (917) 423-2712
    return `(${stripped.slice(1, 4)}) ${stripped.slice(4, 7)}-${stripped.slice(7, 11)}`;
  }

  return stripped;
}

export function formatDobForApi(dob: string): string {
  return format(parse(dob, 'MM/dd/yyyy', new Date()), 'yyyy-MM-dd');
}
